import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Under your co-leadership, Mashreq achieved record results in 2024. What were the
                key levers behind this performance, and how are you sustaining this momentum into
                2025 and beyond?
              </strong>
            </h5>

            <h5 className="text-white">
              2023 and 2024 were transformative years for Mashreq reporting record growth and
              results, but more importantly, it showed the power of agility and disciplined
              execution. We recalibrated plans early, managed capital with precision, and doubled
              down on strategic growth areas - delivering a 29% ROE, stronger capital ratios, and an
              improved cost-to-income of 28%. Furthermore, we executed two major market transactions
              - a USD 500M Tier 1 issuance and our debut Sukuk, both heavily oversubscribed,
              reinforcing investor confidence. The 65% sale of Neopay unlocked AED 1.3 billion in
              profit and positioned our payments business for accelerated growth. In parallel,
              Mashreq was designated by the CBUAE as a UAE D-SIB (Domestic Systemic Important Bank)
              and achieved rating upgrades that now place us A-rated by all three global agencies.
              These milestones build a resilient foundation. Looking ahead, we will leverage this
              strength for further growth domestically and internationally, scale AI-driven
              capabilities, embed best in class governance even deeper, positioning ourselves even
              more prominently as one of the UAE’s leading banks.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You're leading a finance transformation anchored in AI and data-driven
                decision-making. How do you see the role of the CFO evolving with these
                technologies?
              </strong>
            </h5>
            <h5 className="text-white">
              The CFO role has shifted from being a gatekeeper to becoming a true driver of
              transformation. At Mashreq, we’re not waiting for technology to happen to us - we are
              pioneering its adoption within finance and shaping how it serves the wider bank, and
              more important our customers. The old transformation model, with finance as a
              gatekeeper and tech as an IT center of excellence, is obsolete. Breakthroughs come
              when both functions work together in a Transformation Office, ensuring investments
              deliver timely on their promises and that our biggest bets are technologically
              brilliant and commercially sound. In parallel, we run fortnightly AI steering
              committees, accelerating use cases like predictive forecasting, stress testing, and
              automation of reconciliations. Furthermore, I believe the CFO must co-own this agenda
              - championing digital capabilities and ensuring they deliver tangible business value.
              This is how we turn technology from a cost into an engine of sustainable growth and
              improving cost efficiency.
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-How are you embedding ESG principles into financial and real estate strategy at
                Mashreq, and what role does finance play in accelerating sustainability goals?
              </strong>
            </h5>
            <h5 className="text-white">
              ESG is no longer a separate agenda; it is embedded in how we operate and allocate
              capital. At Mashreq, we have made tangible progress - from achieving seven LEED
              certifications across our global portfolio, including LEED Zero Carbon and LEED Zero
              Energy for our Dubai HQ, to securing ISO 50001 certification for energy management.
              These are not just badges; they reflect a disciplined approach to reducing our
              environmental footprint. In parallel, we’ve committed USD 30 billion in sustainable
              financing by 2030 and executed landmark sustainability-linked loans that tie pricing
              to measurable ESG outcomes. Furthermore, finance plays a critical role in making ESG
              real - ensuring that commitments translate into capital allocation, governance, and
              clear KPIs. This is how we align sustainability with long-term value creation and
              position Mashreq as a responsible and future-ready bank.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As someone who has worked across ING and KPMG globally, how has your international
                experience shaped your approach to financial strategy and governance in the MENA
                region?
              </strong>
            </h5>
            <h5 className="text-white">
              My international experience taught me that strong governance and agility must go hand
              in hand. For example, at ING, I learned how to manage and grow a large financial
              institution while adhering to complex regulatory frameworks as well as drive
              large-scale transformations; at KPMG, I built a deep foundation in processes &
              controls, financial integrity while serving clients who transform their business and
              deal with post M&A integrations. Bringing that to MENA, I’ve focused on
              professionalizing the finance function and Mashreq at large further in order to meet
              higher regulatory requirements (like ICFR, see my latest article in Arabian Business)
              while creating the flexibility this fast-paced region demands. Strong governance
              doesn’t slow us down - it creates the foundation to further innovate and invest at
              scale, which is critical as we lead the bank’s next phase of digital and strategic
              growth.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You’re an advocate for finance as a strategic partner and for talent development.
                What steps are you taking to build high-performing, diverse teams and nurture future
                financial leaders, particularly Emirati talent?
              </strong>
            </h5>
            <h5 className="text-white">
              People are at the heart of each organization and thus vital to every transformation. A
              high-performing finance team is not just about technical skills; it’s about creating a
              culture where people feel empowered to challenge, innovate, and lead. Leadership
              starts with trust and clarity - giving people the confidence to make decisions and the
              space to grow. Furthermore, diversity is critical, not just in where you come from but
              in how you think. Different perspectives lead to better outcomes and stronger ideas.
              Emiratization plays an important role in this vision. We’ve significantly increased
              Emirati representation in senior finance roles, and I was recently a judge at the
              INJAZ program - an experience that impressed me deeply. Seeing young Emiratis present
              well-structured business cases with confidence reaffirmed my belief in their potential
              to lead. It echoes the words of His Highness Sheikh Mohammed bin Rashid: “Our real
              wealth lies in our people, and the development of our human capital is our highest
              priority.” For me, investing in talent is not optional; it is how we future-proof the
              function and build a team that shapes strategy and drives sustainable success.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
